import type { UserDto, UserInputDto, UserShiftAreaInformationDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  apiName = 'Default';
  

  getAllUsersByInput = (input: UserInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, UserDto[]>({
      method: 'GET',
      url: '/api/app/user/users',
      params: { id: input.id, filter: input.filter },
    },
    { apiName: this.apiName,...config });
  

  getCurrentUserAreaShiftInformation = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, UserShiftAreaInformationDto>({
      method: 'GET',
      url: '/api/app/user/current-user-area-shift-information',
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
